<template>
  <b-row>
    <b-col
      v-for="(item, i) in trackings"
      :key="item.trackingId"
      cols="12"
      class="list-group list-group-circle text-left m-1"
    >
      <div class="d-flex list-group-item">
        <div class="">
          <h5
            :class="
              'mb-0 ' +
                (IsLastTrackingComplaint(item) === true ? 'text-success' : '')
            "
          >
            {{ i + 1 }}. {{ item.name }}
            <span v-if="item.provincename != null">{{
              item.provincename
            }}</span>
          </h5>
          <!-- <small class="text-muted">{{ item.createTracking }}</small> -->
        </div>
        <div class="col ml-auto">
          <hr class="my-12 bg-dark" />
        </div>
      </div>

      <div
        v-for="(item2, index2) in item.detailList"
        :key="index2"
        class="d-flex justify-content-round ml-2 mr-5"
      >
        <div
          v-for="(item3, index3) in item2.lv"
          :key="index3"
          :class="
            'w-100 ' +
              (IsLastTrackingComplaintDetail(item, item2) == true
                ? 'text-primary'
                : '')
          "
        >
          <!-- <div class="d-flex justify-content-between mb-1">
                    <span></span>
                    <small class="mb-0">{{ item2.createTrackingStr }}</small>
                  </div>
                  <div class="d-flex justify-content-between mb-1">
                    <span class="mb-0">
                      {{ item3.description }}
                      <span v-for="(item4, index4) in item3.st" :key="index4">
                        {{ item4.stDes }}
                      </span>
                    </span>
                  </div> -->

          <div class="d-flex justify-content-between ml-2">
            <span class="mb-0">
              {{ index2 + 1 }} ) {{ item3.description }}
              <span v-for="(item4, index4) in item3.st" :key="index4">
                {{ item4.stDes }}
              </span>
            </span>
          </div>

          <div class="d-flex justify-content-between ml-2 text-left">
            <small class="mb-0"> {{ item2.createTrackingStr }}</small>
            <small
              v-for="(item4, index4) in item3.st"
              :key="index4"
              class="d-flex justify-content-between ml-2"
            >
              <span v-for="(item5, index5) in item4.u" :key="index5">
                <b> {{ item5.fName }} {{ item5.lName }} </b>

                <span v-for="(item6, index6) in item5.u2" :key="index6">
                  <b v-if="item6.fName != null">
                    ส่งต่อ {{ item6.fName }} {{ item6.lName }}</b
                  >
                </span>
              </span>
            </small>
          </div>

          <div class="d-flex justify-content-between ml-2" v-if="item2.comment">
            <span class="mb-0">
              <b> ความคิดเห็น : </b> {{ item2.comment }}
            </span>
          </div>

          <div
            class="d-flex justify-content-between ml-2"
            v-if="hightlightLasted === true"
          >
            <span class="mb-1">
              <b-button
                variant="warning"
                @click="
                  onUpdateCommentButtonClicked(
                    item2.trackingDetailId,
                    item2.comment
                  )
                "
              >
                แก้ไขความเห็นเจ้าหน้าที่
              </b-button>
            </span>
          </div>

          <b-row
            v-for="file in filterTrackingDetailAttachFile(
              item2.trackingDetailId
            )"
            :key="file.attachId"
            class="col-12 m-1 "
          >
            <b-col md="12">
              <a
                :href="file.filePath"
                :download="file.fileName"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-arrow-down-circle"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="8 12 12 16 16 12" />
                  <line x1="12" y1="8" x2="12" y2="16" />
                </svg>
                {{ file.fileName }}
              </a>
            </b-col>
          </b-row>

          <hr class="my-12 bg-dark w-100" />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BButton } from "bootstrap-vue";

import * as storeTracking from "@/store/api/tracking/index.js";
import * as storeDocument from "@/store/api/document/index.js";
import * as storeClue from "@/store/api/clue/index.js";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
  },
  props: { hightlightLasted: false },
  data() {
    return {
      trackings: [],
      trackingDetailAttachFiles: [],
    };
  },
  mounted() {
    this.loadClueTrackingData();
    this.loadClueTrackingDetailAttachFiles();
  },
  methods: {
    loadClueTrackingData() {
      const _this = this;
      console.log("loadClueTrackingData");

      storeTracking
        .getClueTrackingDetail(_this.$route.query.id)
        .then((response) => {
          console.log("getClueTrackingDetail", response);
          _this.trackings = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    loadClueTrackingDetailAttachFiles() {
      const _this = this;
      const params = {
        clueId: this.$route.query.id,
      };

      storeDocument
        .getClueAttachFile(params)
        .then((response) => {
          _this.trackingDetailAttachFiles = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onUpdateCommentButtonClicked(trackingDetailId, oldComment) {
      try {
        this.$emit("handle-update-comment", trackingDetailId, oldComment);
      } catch (ex) {
        console.log("catch" + ex);
      }
    },
    filterTrackingDetailAttachFile(trackingDetailId) {
      try {
        if (this.trackingDetailAttachFiles === undefined) {
          return [];
        }

        const filterAttach = this.trackingDetailAttachFiles.filter((value) => {
          return value.trackingDetailId === trackingDetailId;
          //return true
        });

        return filterAttach;
      } catch (ex) {
        return [];
      }
    },
    IsLastTrackingComplaint(trackingComplaint) {
      try {
        if (this.hightlightLasted === false) {
          return false;
        }

        var lastTracking = this.trackings.slice(-1)[0];
        console.log("lastTracking", lastTracking, this.trackings);

        if (trackingComplaint.trackingId === lastTracking.trackingId) {
          console.log("equal");
          return true;
        } else {
          console.log(
            trackingComplaint.trackingId,
            "not equal",
            lastTracking.trackingId
          );
        }
        return false;
      } catch (ex) {
        console.log(ex);
        return false;
      }
    },
    IsLastTrackingComplaintDetail(trackingComplaint, trackingComplaintDetail) {
      try {
        var isLastTracking = this.IsLastTrackingComplaint(trackingComplaint);

        if (isLastTracking === true) {
          var lastDetail = trackingComplaint.detailList.slice(-1)[0];
          if (
            trackingComplaintDetail.trackingDetailId ===
            lastDetail.trackingDetailId
          ) {
            return true;
          }
        }

        return false;
      } catch (ex) {
        console.log(ex);
        return false;
      }
    },
  },
};
</script>

<style></style>
